shadow$provide[2342] = function(require,module,exports) {
module.exports=(jspdf);
};